const initialState = {
    to: ''
};

export default initialState;
